<template>
  <div class="tabChange">
    <Tabs>
      <TabPane label="收益明细" icon="logo-usd">
        <div class="filter">
          <span class="marginRt10" style="vertical-align: -1px;">订单时间:</span>
          <DatePicker @on-change="time1" class="time marginRt10" v-model="getTime.time1" type="daterange"
                      placeholder="请选择开始时间，结束时间" :editable='false' style="width: 220px"></DatePicker>
          <Button class="search marginRt10" type="primary" @click="search('1')">查询</Button>
          <Button class="reset marginRt10" @click="reset('1')">重置</Button>
          <div class="rt">
<!--            订单成交额：{{tbl1.allOrderMoney}} <i></i> 预计收益：{{tbl1.allAnticipatedIncome}}-->
            合计预计收益：{{tbl1.allAnticipatedIncome}}
          </div>
        </div>
        <div class="tbl">
          <Table :loading="loading[0]" border :data="tbl1.statisticsList" :columns="columns1"></Table>
          <Page
            :total="total[0]"
            :page-size="params1.pgSize"
            :current="params1.pgIndex"
            @on-change="pageChange1"
            @on-page-size-change="pageSizeChange1"
            show-total show-elevator show-sizer></Page>
        </div>
      </TabPane>
      <TabPane label="提现记录" icon="md-card">
        <div class="filter">
          <DatePicker @on-change="time2" v-model="getTime.time2" class="marginRt10" type="month" format="yyyy-MM"
                      placeholder="请选择时间" :editable='false' style="width: 150px"></DatePicker>
          <!--          <DatePicker @on-change="time3" v-model="getTime.time3" class="marginRt10" type="month" format="yyyy-MM"-->
          <!--                      placeholder="请选择结束时间" :editable='false' style="width: 150px"></DatePicker>-->
          <Button class="search marginRt10" type="primary" @click="search('2')">查询</Button>
          <Button class="reset marginRt10" @click="reset('2')">重置</Button>

          <div class="rt">
            合计税后分成金额：{{tbl2.allWithdrawMoney}}
          </div>
        </div>

        <div class="tbl">
          <Table :loading="loading[1]" border :data="tbl2.withdrawDetailList" :columns="columns2"></Table>
          <Page
            :current="params2.pgIndex"
            :page-size="params2.pgSize"
            :total="total[1]"
            @on-change="pageChange2"
            @on-page-size-change="pageSizeChange2"
            show-elevator show-sizer show-total></Page>
        </div>

      </TabPane>
      <TabPane label="退款明细" icon="md-list-box">
        <div class="filter">
          <span class="marginRt10" style="vertical-align: -1px;">退款时间:</span>
          <DatePicker @on-change="time4" class="time marginRt10" v-model="getTime.time4" type="daterange"
                      placeholder="请选择开始时间，结束时间" :editable='false' style="width: 220px"></DatePicker>
          <Button class="search marginRt10" type="primary" @click="search('3')">查询</Button>
          <Button class="reset marginRt10" @click="reset('3')">重置</Button>

          <div class="rt">
            退款金额：{{tbl3.allRefoundMoney}}
          </div>
        </div>

        <div class="tbl">
          <Table :loading="loading[2]" border :data="tbl3.refoundList" :columns="columns3"></Table>
          <Page
            :total="total[2]"
            :page-size="params3.pgSize"
            :current="params3.pgIndex"
            @on-change="pageChange3"
            @on-page-size-change="pageSizeChange3"
            show-total show-elevator show-sizer></Page>
        </div>

      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  export default {
    name: "tabChange",
    data() {
      return {
        loading: [true, true, true],
        getTime: {
          time1: ['', ''],
          time2: '',
          time3: '',
          time4: ['', ''],
        },
        params1: {
          unionID: '',
          seacherContext: '',
          type: '',
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        },
        params2: {
          unionID: '',
          seacherContext: '',
          type: '',
          startTime: '',
          // endTime: '',
          pgIndex: 1,
          pgSize: 10,
        },
        params3: {
          unionID: '',
          seacherContext: '',
          type: '',
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        },
        state: [
          {
            num: 0,
            value: '重复付款'
          }, {
            num: 1,
            value: '优惠退款'
          }, {
            num: 2,
            value: '教材退款'
          }, {
            num: 3,
            value: '换课退款'
          }, {
            num: 4,
            value: '视频网络'
          }, {
            num: 5,
            value: '老师讲授'
          }, {
            num: 6,
            value: '课程更新'
          }, {
            num: 7,
            value: '客服沟通'
          }, {
            num: 8,
            value: '学员报名'
          }, {
            num: 9,
            value: '客户端问题'
          }, {
            num: 10,
            value: '投诉退款'
          }, {
            num: 11,
            value: '取消考试'
          }, {
            num: 12,
            value: '网校误导学员'
          }, {
            num: 13,
            value: '教材不符'
          }, {
            num: 14,
            value: '程序BUG'
          }, {
            num: 15,
            value: '课程下线'
          }, {
            num: 16,
            value: '没时间学习'
          }, {
            num: 17,
            value: '题库错误'
          }, {
            num: 18,
            value: '地区考试与网校课程不符'
          }, {
            num: 19,
            value: '其他原因'
          }, {
            num: 20,
            value: '无法参加考试'
          }, {
            num: 21,
            value: '不适合自己'
          }, {
            num: 22,
            value: '难度大听不懂'
          }, {
            num: 23,
            value: '保价退款'
          }, {
            num: 24,
            value: '课程质量'
          }, {
            num: 25,
            value: '报考失败'
          }, {
            num: 26,
            value: '差价退款'
          }, {
            num: 27,
            value: '考试不过退费'
          }, {
            num: 28,
            value: '选择其他网校'
          }
        ],
        total: [0, 0, 0],
        tbl1: {},
        columns1: [{
          title: "订单编号",
          key: "orderID",
        }, {
          title: "用户名",
          key: "userName",
          width: 150,
        }, {
          title: "课程明细",
          key: "productNameList",
          width: 300,
          render: (h, {row}) => {
            console.log(row);
            const arr = row.productNameList;//数据数组
            const newArr = [];
            arr.forEach((info) => {
              newArr.push(h('div', {
                  style: {
                    marginBottom: '6px'
                  }
                },
                [
                  h('p', {
                    style: {
                      marginBottom: '4px'
                    }
                  }, info),
                ]
              ))
            });

            return h('div', newArr)
          }
        }, {
          title: "支付时间",
          key: "payTime",
          width: 200
        }, {
          title: "可提成订单金额",
          key: "canGetOrderMoney",
        }, {
          title: "分成比例",
          key: "proportion",
          render: (h, params) => {
            return h("span", params.row.proportion + '%')
          }
        }, {
          title: "预计收益",
          key: "canGetMoney",
        }],
        tbl2: {},
        columns2: [{
          title: "ID",
          key: "id",
          width: 160
        }, {
          title: "汇款时间",
          key: "addTime",
          width: 200
        }, {
          title: "税前分成金额",
          key: "pretaxMoney",
        }, {
          title: "税后分成金额",
          key: "money",
        }, {
          title: "到帐银行",
          key: "dueBank",
        }, {
          title: "银行卡号",
          key: "bankCard",
        }],
        tbl3: {},
        columns3: [{
          title: "订单编号",
          key: "orderID",
        }, {
          title: "用户名",
          key: "userName",
        }, {
          title: "课程班级",
          key: "productName",
        }, {
          title: "退款金额",
          key: "refoundMoney",
        }, {
          title: "退款原因",
          key: "refoundReason",
          render: (h, params) => {
            const val = this.state.findIndex((value) => value.num === params.row.refoundReason);
            return h("span", {
              style: {
                // color: '#f5222d'
              }
            }, this.state[val].value)
          }
        }, {
          title: "退款成功时间",
          key: "refoundTime",
          width: 200
        }],
      }
    },
    methods: {
      time1(e) {
        this.getTime.time1 = e;
      },
      time2(e) {
        this.getTime.time2 = e;
      },
      time3(e) {
        this.getTime.time3 = e;
      },
      time4(e) {
        this.getTime.time4 = e;
      },
      pageChange1(val) {
        this.params1.pgIndex = val;
        this.getIncomeDetail();
      },
      pageSizeChange1(val) {
        this.params1.pgSize = val;
        this.getIncomeDetail();
      },
      pageChange2(val) {
        this.params2.pgIndex = val;
        this.getWithDetail();
      },
      pageSizeChange2(val) {
        this.params2.pgSize = val;
        this.getWithDetail();
      },
      pageChange3(val) {
        this.params3.pgIndex = val;
        this.getRefoundDetail();
      },
      pageSizeChange3(val) {
        this.params3.pgSize = val;
        this.getRefoundDetail();
      },
      search(val) {
        //1收益明细 2提现记录 3退款明细
        if (val === '1') {
          //去除时间判断限制
          this.params1.startTime = this.getTime.time1[0];
          this.params1.endTime = this.getTime.time1[1];
          this.getIncomeDetail();
        } else if (val === '2') {
          //去除时间判断限制
          if (new Date(this.getTime.time2).getTime() > new Date(this.getTime.time3).getTime()) {
            this.$Message.warning('开始时间不能大于结束时间');
          } else {
            this.params2.startTime = this.getTime.time2;
            this.params2.endTime = this.getTime.time3;
            this.getWithDetail();
          }
        } else if (val === '3') {
          //去除时间判断限制
          this.params3.startTime = this.getTime.time4[0];
          this.params3.endTime = this.getTime.time4[1];
          this.getRefoundDetail();
        }
      },
      reset(val) {
        if (val === '1') {
          // this.loading[0] = true;
          this.getTime.time1 = ['', ''];
          this.params1 = {
            unionID: '',
            seacherContext: '',
            type: '',
            startTime: '',
            endTime: '',
            pgIndex: 1,
            pgSize: 10,
          };
          this.tbl1 = [];
          this.total[0] = 0;
          this.getIncomeDetail();
        } else if (val === '2') {
          // this.loading[1] = true;
          this.getTime.time2 = '';
          this.getTime.time3 = '';
          this.params2 = {
            unionID: '',
            seacherContext: '',
            type: '',
            startTime: '',
            endTime: '',
            pgIndex: 1,
            pgSize: 10,
          };
          this.tbl2 = [];
          this.total[1] = 0;
          this.getWithDetail();
        } else {
          // this.loading[2] = true;
          this.getTime.time4 = ['', ''];
          this.params3 = {
            unionID: '',
            seacherContext: '',
            type: '',
            startTime: '',
            endTime: '',
            pgIndex: 1,
            pgSize: 10,
          };
          this.tbl3 = [];
          this.total[2] = 0;
          this.getRefoundDetail();
        }
      },
      //收益明细
      getIncomeDetail() {
        const {unionID, seacherContext, type, startTime, endTime, pgIndex, pgSize} = this.params1;
        const params = {unionID, seacherContext, type, startTime, endTime, pgIndex, pgSize};
        this.$store.dispatch('effect/getIncomeDetail', params).then(res => {
          if (res) {
            this.tbl1 = res;
            this.total[0] = res.total;
          } else {
            this.tbl1 = {};
            this.total[0] = 0;
          }
          this.loading[0] = false;
        });
      },
      //提现明细
      getWithDetail() {
        const {unionID, seacherContext, type, startTime, pgIndex, pgSize} = this.params2;
        const params = {unionID, seacherContext, type, startTime: startTime + '-01', pgIndex, pgSize};
        this.$store.dispatch('effect/getWithDetail', params).then(res => {
          console.log(res);
          if (res) {
            this.tbl2 = res;
            this.total[1] = res.total;
          } else {
            this.tbl2 = {};
            this.total[1] = 0;
          }
          console.log('111');
          this.loading[1] = false;
        });
      },
      //退款明细
      getRefoundDetail() {
        const {unionID, seacherContext, type, startTime, endTime, pgIndex, pgSize} = this.params3;
        const params = {unionID, seacherContext, type, startTime, endTime, pgIndex, pgSize};
        this.$store.dispatch('effect/getRefoundDetail', params).then(res => {
          if (res) {
            this.tbl3 = res;
            this.total[2] = res.total;
          } else {
            this.tbl3 = {};
            this.total[2] = 0;
          }
          this.loading[2] = false;
        });
      },
      getInfo() {
        this.getIncomeDetail();
        this.getWithDetail();
        this.getRefoundDetail();
      }
    },
    created() {
      this.getInfo();
    }
  }
</script>

<style scoped lang="scss">
  .tabChange {
    margin-top: 10px;

    .filter {
      margin-bottom: 20px;

      .rt {
        float: right;
        margin-top: 5px;

        i {
          display: inline-block;
          width: 50px;
          height: 10px;
        }
      }
    }

    .tbl {
      .ivu-page {
        text-align: right;
        margin: 20px 0;
      }
    }

    .ivu-tabs {
      min-height: 500px;
    }

    .marginRt10 {
      margin-right: 10px;
    }
  }
</style>